import { LoadingDot } from "./loading-dot";

export class Buttons {
  lock(_btn, _text, _addDots = false) {
    _btn.innerHTML = _text;
    if (_addDots === true) {
      _btn.innerHTML += ' ' + (LoadingDot.render()).replace(/div/g, 'span');
    }
    _btn.classList.add('locked');
  }

  hideById(_id) {
    let dom = document.getElementById(_id);
    if (dom) {
      dom.setAttribute('style', 'display: none !important;');
    }
  }
}
